import React, { useRef, useState } from "react";
import { Modal, Select } from "antd";
import { ReactFormBuilder } from "react-form-builder2";
import "react-form-builder2/dist/app.css";
import "font-awesome/css/font-awesome.min.css";
import axios from "../../../helpers/axios";
import { IMAGE_BASE_URL } from "../../../helpers/constants";

const { Option } = Select;

// Allowed custom field types
const customItems = [
  { key: "Header", name: "Header" },
  { key: "TextInput", name: "Text Input" },
  { key: "DatePicker", name: "Date" },
  { key: "Dropdown", name: "Select" },
  { key: "RadioButtons", name: "Radio" },
  { key: "Checkboxes", name: "Checkbox" },
];

const AddDeclarationModal = ({ open, onClose, handleSave, loanProvider, declarationFormData }) => {
  const builderRef = useRef(null);
  const formDataRef = useRef([]);
  const [products, setProducts] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [newDeclarationFormData, setNewDeclarationFormData] = useState(declarationFormData);

  const fetchProducts = async () => {
    if (!loanProvider) return;
    try {
      const response = await axios.get(`/admin/loan/product/form-filter`, {
        params: { loan_provider: loanProvider },
      });
      const fetchedData = response.data.data?.products || [];
      setProducts(fetchedData);
      console.log("Fetched products:", fetchedData);
      console.log(fetchedData.form_data)
    } catch (error) {
      console.error("Error fetching products:", error);
    }
  };

  const fetchProductForm = (productId) => {
    console.log("Selected productId:", productId);
    const selected = products.find((p) => p.id === productId);
    if (selected) {
      const formData = selected.form_data ? JSON.parse(selected.form_data) : [];
      console.log("Matched form_data:", formData);
      setNewDeclarationFormData(formData);
      formDataRef.current = formData;
    } else {
      console.warn("Product not found for form_data");
    }
  };

  const onOk = () => {
    handleSave(formDataRef.current);
    console.log("Fetched form data:", formDataRef.current);

    onClose();
  };

  return (
    <Modal
      title="Add Declaration"
      open={open}
      onOk={onOk}
      onCancel={onClose}
      width={1000}
      destroyOnClose
      style={{ maxHeight: "70vh", overflowY: "hidden" }}
    >
      {/* Product Dropdown */}
      <Select
        style={{ width: 700, marginBottom: 20 }}
        placeholder="Select Product Name"
        value={selectedProduct}
        showSearch
        onChange={(value) => {
          console.log("selected value===========", value);
          setSelectedProduct(value);
          fetchProductForm(value);
        }}
        onOpenChange={(open) => {
          if (open && products.length === 0) {
            fetchProducts();
          }
        }}
        optionLabelProp="label"
        getPopupContainer={(trigger) => trigger.parentNode}
      >
        {products
          .filter((item) => item.form_data && item.form_data !== "[]")
          .map((item) => {
            const infoParts = [
              item.vehicle?.name,
              item.categoryinfo?.name,
              item.typeinfo?.name,
              item.motor_typeinfo?.name,
              item.usageinfo?.name,
              item.schemeinfo?.name,
              item.approvaltimeinfo?.name,
              item.ltvinfo?.name,
            ].filter(Boolean);

            const iconUrl =
              item.icon && item.icon !== ""
                ? `${IMAGE_BASE_URL}/${item.icon}`
                : "/no-image.png";

            return (
              <Option
                key={item.id}
                value={item.id}
                label={
                  <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                    <img
                      src={iconUrl}
                      alt={item.name}
                      style={{
                        width: 22,
                        height: 22,
                        borderRadius: 4,
                        objectFit: "cover",
                        background: "#f8f8f8",
                      }}
                    />
                    <span style={{ fontWeight: 500 }}>{item.name}</span>
                  </div>
                }
              >
                <div style={{ display: "flex", flexDirection: "column", lineHeight: "1.3" }}>
                  <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                    <img
                      src={iconUrl}
                      alt={item.name}
                      style={{
                        width: 28,
                        height: 28,
                        borderRadius: 6,
                        objectFit: "cover",
                        background: "#f8f8f8",
                      }}
                    />
                    <span style={{ fontWeight: 500 }}>{item.name}</span>
                  </div>

                  {infoParts.length > 0 && (
                    <span style={{ fontSize: 12, color: "#888", marginTop: 5, marginLeft: 36 }}>
                      {infoParts.join(" • ")}
                    </span>
                  )}
                </div>
              </Option>
            );
          })}
      </Select>

      {/* ReactFormBuilder */}
      <div style={{ maxHeight: "50vh", overflowY: "auto" }}>
        <ReactFormBuilder
          key={selectedProduct || "new"}
          ref={builderRef}
          toolbarItems={customItems}
          data={newDeclarationFormData}
          onPost={(data) => {
            if (data?.task_data) formDataRef.current = data.task_data;
            console.log("open", data?.task_data)
          }}
        />
      </div>
    </Modal>
  );
};

export default AddDeclarationModal;
